import { render } from "./FeedBackIzvestajSvi.vue?vue&type=template&id=56a03e6f&scoped=true&lang=html"
import script from "./FeedBackIzvestajSvi.vue?vue&type=script&lang=js"
export * from "./FeedBackIzvestajSvi.vue?vue&type=script&lang=js"

import "./FeedBackIzvestajSvi.vue?vue&type=style&index=0&id=56a03e6f&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-56a03e6f"

export default script